import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Clapperboard, Loader2, Save } from "lucide-react";

const TIERS = [
  { key: "free", label: "Free Member", color: "text-zinc-300" },
  { key: "vip", label: "VIP", color: "text-pb-red" },
  { key: "ace", label: "ACE", color: "text-pb-cyan" },
  { key: "goat", label: "GOAT", color: "text-amber-400" },
];

export default function VideoPricingPanel() {
  const [rates, setRates] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/admin/video-pricing").then(({ data }) => setRates(data.rates)).catch(() => {});
  }, []);

  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put("/admin/video-pricing", {
        free: Number(rates.free) || 0, vip: Number(rates.vip) || 0,
        ace: Number(rates.ace) || 0, goat: Number(rates.goat) || 0,
      });
      setRates(data.rates);
      toast.success("Drill video analysis rates updated across the site");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  if (!rates) return null;
  return (
    <div className="bg-pb-surface border border-pb-border p-6" data-testid="video-pricing-panel">
      <div className="flex items-center gap-2 mb-1">
        <Clapperboard className="w-4 h-4 text-pb-red" />
        <span className="font-display font-bold text-lg uppercase">AI Drill Video Pricing</span>
      </div>
      <p className="text-xs text-zinc-500 mb-5">
        BULLION coins charged per drill video a member submits for AI analysis, by membership. Coins go to the treasury (BLC-BULLPEN);
        failed analyses are auto-refunded. Set 0 for free. Everyone's FIRST game-film assessment stays free (base score).
      </p>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-5">
        {TIERS.map((t) => (
          <div key={t.key}>
            <label className={`block text-[10px] uppercase tracking-[0.2em] mb-2 font-bold ${t.color}`}>{t.label}</label>
            <div className="flex items-center bg-pb-elevated border border-pb-border focus-within:border-pb-red">
              <input data-testid={`video-rate-${t.key}`} type="number" min={0} max={1000} step="0.5"
                value={rates[t.key]}
                onChange={(e) => setRates({ ...rates, [t.key]: e.target.value })}
                className="w-full bg-transparent pl-3 pr-1 py-2.5 text-white font-mono focus:outline-none" />
              <span className="pr-3 text-[10px] text-zinc-500 font-bold">BLC</span>
            </div>
          </div>
        ))}
      </div>
      <button data-testid="video-pricing-save" onClick={save} disabled={busy}
        className="flex items-center gap-1.5 bg-pb-red text-black font-bold uppercase tracking-widest px-6 py-2.5 text-xs hover:bg-[#BEF264] active:scale-95 transition-all disabled:opacity-50">
        {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Save className="w-3.5 h-3.5" />} Save Rates
      </button>
    </div>
  );
}
